import { Component, Input } from '@angular/core';
var HTML_TEMPLATE = "<od-badge [text]=\"_text\" [color]=\"_color\" [size]=\"_size\"></od-badge>";
var NumberBadge = /** @class */ (function () {
    function NumberBadge() {
        this._maxData = 1;
        this.data = 0;
    }
    Object.defineProperty(NumberBadge.prototype, "maxData", {
        set: function (value) {
            this._maxData = value;
            this.calculateText();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumberBadge.prototype, "data", {
        set: function (value) {
            this._data = value;
            this.calculateText();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumberBadge.prototype, "size", {
        set: function (value) {
            if (value != null)
                this._size = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumberBadge.prototype, "color", {
        set: function (value) {
            if (value != null)
                this._color = value;
        },
        enumerable: true,
        configurable: true
    });
    NumberBadge.prototype.calculateText = function () {
        this._text = (this._maxData > this._data) ? "" + this._data : "+" + this._maxData;
    };
    NumberBadge.decorators = [
        { type: Component, args: [{
                    selector: 'od-number-badge',
                    template: HTML_TEMPLATE
                },] },
    ];
    /** @nocollapse */
    NumberBadge.ctorParameters = function () { return []; };
    NumberBadge.propDecorators = {
        "maxData": [{ type: Input },],
        "data": [{ type: Input },],
        "size": [{ type: Input },],
        "color": [{ type: Input },],
    };
    return NumberBadge;
}());
export { NumberBadge };
//# sourceMappingURL=number-badge.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/badge/number-badge.js
// module id = 419
// module chunks = 14